import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  getAttempt: null,
  getError: ['error'],
  getSuccess: ['detail']
}, {prefix: "GROUPS_"});
